import { gql } from '@apollo/client';

// Operation name must stay exactly "FunnelDashboard" — it's on the backend's auth-bypass
// allowlist (server.ts) so the password itself can act as the auth, checked server-side.
export const FUNNEL_DASHBOARD = gql`
    query FunnelDashboard($password: String!, $days: Int, $platform: String) {
        funnelDashboard(password: $password, days: $days, platform: $platform) {
            status
            data {
                androidFunnel { label count percent }
                iosFunnel { label count percent }
                stuckSessions { sessionId email code communityName platform reachedLabel lastEventAt }
                helpRequests { email code communityName createdAt }
                byCommunity { code communityName started reachedStore stuckCount signups }
                recentEvents { eventType sessionId platform code detail createdAt }
            }
        }
    }
`;
